import AuthPage from '../auth/index';
import ChangePassword from '../auth/ChangePassword';
import ChangePasswordSuccess from '../auth/ChangePasswordSuccess';
import ForgotPassword from '../auth/ForgotPassword';
import ForgotPasswordSuccess from '../auth/ForgotPasswordSuccess';
import Register from '../auth/Register';
import RegisterSuccess from '../auth/RegisterSuccess';
import ResetPassword from '../auth/ResetPassword';
import ResetPasswordSuccess from '../auth/ResetPasswordSuccess';
import { lazyComponent } from '../shared/util/lazyLoad';
import { pageLoadingFallback } from './pageLoading';

/**
 * The screens the route table mounts itself, rather than through a plugin page
 * (`pluginPages.js`).
 *
 * The auth screens load with the app. The login page is the first thing a signed-out admin
 * sees, and it should not open on a loading ring. They render before a tenant config exists,
 * outside the frame, so none of them reads the CMS context.
 */
export const authScreens = {
  login: AuthPage,
  changePassword: ChangePassword,
  changePasswordSuccess: ChangePasswordSuccess,
  forgotPassword: ForgotPassword,
  forgotPasswordSuccess: ForgotPasswordSuccess,
  resetPassword: ResetPassword,
  resetPasswordSuccess: ResetPasswordSuccess,
  register: Register,
  registerSuccess: RegisterSuccess,
};

/**
 * The frame's own screens load the first time they open, as the plugin pages do. Each has a
 * `preload()` that the route calls as it matches and the rail calls on hover.
 */
const lazyScreen = (load) => lazyComponent(load, pageLoadingFallback);
export const ManageAdmins = lazyScreen(() => import('../admins/pages/AdminListPage'));
export const ManageSubtenants = lazyScreen(() => import('../subtenants/pages/SubtenantListPage'));
export const ChangePasswordEditorPage = lazyScreen(() =>
  import('../auth/ChangePasswordEditorPage')
);
